import React from "react";
import { Button } from "../ui/button";
import { Badge } from "../ui/badge";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "../ui/dialog";
import { Loader2, History } from "lucide-react";
import { fmtDateTimeEST } from "../../utils/dateUtils";

const LoginHistoryDialog = React.memo(function LoginHistoryDialog({
  open, onOpenChange, loginHistoryUser, loginHistory, loadingHistory
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-4xl max-h-[80vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <History className="h-5 w-5 text-blue-600" />
            Login History - {loginHistoryUser?.full_name}
          </DialogTitle>
          <DialogDescription>
            Recent login activity for this user (last 50 logins)
          </DialogDescription>
        </DialogHeader>

        <div className="py-4">
          {loadingHistory ? (
            <div className="flex items-center justify-center py-12">
              <Loader2 className="h-8 w-8 animate-spin text-primary" />
            </div>
          ) : loginHistory.length === 0 ? (
            <div className="text-center py-12 text-slate-500">
              <History className="h-12 w-12 mx-auto mb-4 text-slate-300" />
              <p className="font-medium">No login history found for this user</p>
              <p className="text-sm mt-2">Login history is recorded when the user logs in from a web browser.</p>
            </div>
          ) : (
            <div className="overflow-x-auto">
              <table className="w-full data-table">
                <thead>
                  <tr>
                    <th>Date & Time</th>
                    <th>IP Address</th>
                    <th>Browser</th>
                    <th>Operating System</th>
                    <th>Device Type</th>
                  </tr>
                </thead>
                <tbody>
                  {loginHistory.map((login) => (
                    <tr key={login.id}>
                      <td className="whitespace-nowrap">
                        {fmtDateTimeEST(login.logged_in_at)}
                      </td>
                      <td className="font-mono text-sm">{login.ip_address}</td>
                      <td>
                        {login.browser_name && login.browser_version ? (
                          <span>
                            {login.browser_name} {login.browser_version}
                          </span>
                        ) : (
                          <span className="text-slate-400">Unknown</span>
                        )}
                      </td>
                      <td>
                        {login.os_name && login.os_version ? (
                          <span>
                            {login.os_name} {login.os_version}
                          </span>
                        ) : (
                          <span className="text-slate-400">Unknown</span>
                        )}
                      </td>
                      <td>
                        <Badge
                          variant="outline"
                          className={
                            login.device_type === "Mobile"
                              ? "bg-blue-50 text-blue-700 border-blue-200"
                              : login.device_type === "Tablet"
                              ? "bg-purple-50 text-purple-700 border-purple-200"
                              : "bg-slate-50 text-slate-700 border-slate-200"
                          }
                        >
                          {login.device_type || "Unknown"}
                        </Badge>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>

        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            Close
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
});

export default LoginHistoryDialog;
